import { TopBar, Navigation } from '@/components/Navigation';
import { Footer } from '@/components/Footer';
import { Memberships } from '@/components/home/Memberships';
import { FAQTarifs } from '@/components/tarifs/FAQTarifs';
import { PageMeta, BreadcrumbJsonLd } from '@/components/PageMeta';
import { PageHero } from '@/components/PageHero';
import { ScrollProgressBar } from '@/components/ScrollProgressBar';
import { BOX_IMAGES } from '@/data/images';

export default function TarifsPage() {
  return (
    <div className="min-h-screen">
      <PageMeta title="Tarifs" description="Tarifs CrossFit Saint-Chamond : abonnements de 59€ à 99€/mois, carnets de séances, drop-in. Sans engagement, accessible à tous." path="/tarifs" />
      <BreadcrumbJsonLd items={[{ name: 'Accueil', url: '/' }, { name: 'Tarifs' }]} />
      <ScrollProgressBar />
      <TopBar />
      <Navigation />

      <PageHero
        pageKey="/tarifs"
        eyebrow="Tarifs"
        title="OFFRES TARIFAIRES"
        highlight="TARIFAIRES"
        subtitle="CrossFit & HYROX Training Club — Sans engagement, préavis de 2 mois. Frais d'adhésion 99€."
        image={BOX_IMAGES.dbSnatch}
        alt="CrossFit Saint-Chamond - Tarifs et abonnements"
        breadcrumbs={[{ name: 'Accueil', href: '/' }, { name: 'Tarifs' }]}
      />

      <Memberships />

      <FAQTarifs />

      <Footer />
    </div>
  );
}
